import xss from 'xss';
import { getCookie } from './index';

export const deleteCookie = (name) => {
  const date = new Date();
  date.setTime(date.getTime() + -3 * 24 * 60 * 60 * 1000);
  const domainName = window.location.hostname;
  const getTheHostName = domainName.split('.')[1];
  const subDomainName = domainName.split('.')[2];
  const domainString = `${getTheHostName}.${subDomainName}`;
  if (domainName === 'localhost') document.cookie = `${name}=;path=/;`;
  // document.cookie = `${name}=;path=/;expires=${date.toGMTString()};domain=.${domainString}`;
  document.cookie = `${xss(name)}=${xss(encodeURIComponent(''))};path=/;expires=${date.toGMTString()};domain=.${xss(domainString)}`;
  if (window.vzFlags?.enableCookieKeys) {
    window.CookieKeys = document.cookie?.split(';')?.reduce((a, c) => a.set(c?.split('=')?.[0]?.trim(), c?.split('=')?.[1]?.trim()), new Map());
  }
};

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');
  const date = new Date();
  const domainName = window.location.hostname;
  const getTheHostName = domainName.split('.')[1];
  const subDomainName = domainName.split('.')[2];
  const domainString = `${getTheHostName}.${subDomainName}`;
  date.setTime(date.getTime() + -3 * 24 * 60 * 60 * 1000);
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    // document.cookie = `${name}=;path=/;expires=${date.toGMTString()}`;
    document.cookie = `${xss(name)}=${xss(encodeURIComponent(''))};path=/;expires=${date.toGMTString()}`;
    // adding it to delete cookie created by us.
    // document.cookie = `${name}=;path=/;expires=${date.toGMTString()};domain=.${domainString}`;
    document.cookie = `${xss(name)}=${xss(encodeURIComponent(''))};path=/;expires=${date.toGMTString()};domain=.${xss(domainString)}`;
    if (window.vzFlags?.enableCookieKeys) {
      window.CookieKeys = document.cookie?.split(';')?.reduce((a, c) => a.set(c?.split('=')?.[0]?.trim(), c?.split('=')?.[1]?.trim()), new Map());
    }
  }
};

export const isCookieExists = (name) => {
  if (getCookie(name)?.trim()) {
    return name;
  }
  return false;
};

export const getScreenedCookieValue = (name) => {
  const disable_read_cookie = (window.vzFlags && window.vzFlags.disable_read_cookie) || false;
  return disable_read_cookie ? '' : getCookie(name);
};

export const setCookie = (cookieName, value) => {
  const domainName = window.location.hostname;
  const getTheHostName = domainName?.split('.')[1];
  const subDomainName = domainName?.split('.')[2];
  const domainString = `${getTheHostName}.${subDomainName}`;
  if (domainName === 'localhost') document.cookie = `${xss(cookieName)}=${xss(value)};path=/;`;
  // document.cookie = `${cookieName}=${value};path=/;domain=.${domainString}`;
  document.cookie = `${xss(cookieName)}=${xss(value)};path=/;domain=.${xss(domainString)}`;
  if (window.vzFlags?.enableCookieKeys) {
    window.CookieKeys = document.cookie?.split(';')?.reduce((a, c) => a.set(c?.split('=')?.[0]?.trim(), c?.split('=')?.[1]?.trim()), new Map());
  }
};
